export default __webpack_public_path__ + "static/media/Asset2.99d3f124.svg";